(() => {
  document.addEventListener('change', event => {
    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker) return;
    const scope = picker.closest('.shopify-section') || document;
    const gallery = scope.querySelector('.an-approved-gallery[data-color-images]');
    if (!gallery) return;
    let images;
    try { images = JSON.parse(gallery.dataset.colorImages); } catch { return; }
    const choices = [...picker.querySelectorAll('input:checked, select')];
    const color = choices.map(input => input.value).find(value => images[value]);
    if (!color || gallery.dataset.currentColor === color) return;
    const img = gallery.querySelector('img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.src = images[color];
    img.alt = gallery.dataset.productTitle + ' · ' + color;
    gallery.dataset.currentColor = color;
  });
})();